<template>
  <div :class="['navigation-bar', {'navigation-bar--open': isOpen}]">
    <button class="navigation-bar__toggle-icon" @click="toggleNavigation">
      <span :class="[{'active': isOpen}]"></span>
    </button>

    <div class="navigation-bar__contest-name">
      <template v-if="lang === 'en'">
        <img src="/dist/mentos-logo-en.png"/>
        <span><b>Mentos</b> presents</span>
      </template>

      {{ $t("navigationBar.title", lang) }}

      <template v-if="lang === 'fr'">
        <span>présenté par <b>Mentos</b></span>
        <img src="/dist/mentos-logo-fr.png"/>
      </template>
    </div>

    <nav class="navigation-bar__list">
      <ul>
        <li>
          <button
            @click="scrollToSection('#contest-vue')"
            class="navigation-bar__list-item">{{ $t("navigationBar.backToTop", lang) }}</button>
        </li>

        <li>
          <button
            @click="scrollToSection('#map-and-feeds')"
            class="navigation-bar__list-item">{{ $t("navigationBar.niceToMentosYou", lang) }}</button>
        </li>

        <li>
          <a :href="$t('navigationBar.goToMentosUrl', lang)" target="_blank" class="navigation-bar__list-item">{{ $t("navigationBar.goToMentos", lang) }}</a>
        </li>

        <li>
          <button
            @click="toggleLanguage"
            class="navigation-bar__list-item">{{ $t("navigationBar.language", lang) }}</button>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import VueScrollTo from "vue-scrollto";

export default {
  name: "navigation-bar",

  props: {
    lang: { type: String, required: true }, // Lang binded from parent.
  },

  data() {
    return {
      isOpen: false
    }
  },

  methods: {
    toggleNavigation() {
      this.isOpen = (this.isOpen === false);
    },

    scrollToSection(elementId) {
      this.isOpen = false;
      VueScrollTo.scrollTo(elementId, 700, { easing: "ease" });
    },

    toggleLanguage() {
      this.isOpen = false;
      VueEvents.$emit("toggle-language");
    }
  }
}
</script>



// WEBPACK FOOTER //
// NavigationBar.vue?045ec0cf